import React from "react";

import { Svg } from "./partials/Svg";
import { Group } from "./partials/Group";
import { NumberChart } from "./partials/NumberChart";
import { ChartProps } from "./Chart";

import { chartColors } from "../../config/colors";
import { margin } from "../../config/spacing";

export const ArcticSeaLevel: React.FC<ChartProps> = ({
  id,
  width = 250,
  height = 400,
  isAnimated = true,
}) => {
  return (
    <Svg id={id} width={width} height={height}>
      <Group transform={`translate(${margin.left}, ${margin.top})`}>
        <Group transform="translate(0, 0)">
          <NumberChart
            id="sea-level"
            text={"+21 cm"}
            title={"Meeresspiegel"}
            description={
              "Durchschnittlicher Anstieg des\nMeeresspiegels seit 1900"
            }
            source={"NASA"}
            sourceLink={"https://climate.nasa.gov/vital-signs/sea-level/"}
            infoLink={"https://www.ardalpha.de/klimazahlen-meeresspiegel-100.html"}
            color={chartColors.darkBlue}
            isAnimated={isAnimated}
          />
        </Group>
        <Group transform={`translate(0, ${height / 2})`}>
          <NumberChart
            id="arctic-ice"
            text={"-16 %"}
            title={"Arktisches Eis"}
            description={
              "Abnahme des arktischen Meereis\nim Vergleich zu 1979 bis 1990"
            }
            source={"NSIDC"}
            sourceLink={
              "https://nsidc.org/arcticseaicenews/charctic-interactive-sea-ice-graph/"
            }
            infoLink={"https://www.ardalpha.de/klimazahlen-arktisches-eis-100.html"}
            color={chartColors.green}
            isAnimated={isAnimated}
          />
        </Group>
      </Group>
    </Svg>
  );
};
